/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkReservationtype } from '../models/work-reservationtype';

@Injectable({ providedIn: 'root' })
export class WorkReservationtypesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `reservationtypesV1ControllerFindAll()` */
  static readonly ReservationtypesV1ControllerFindAllPath = '/v1/reservationtypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationtypesV1ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationtypesV1ControllerFindAll$Response(
    params: {
      businessunitId: number;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkReservationtype>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationtypesService.ReservationtypesV1ControllerFindAllPath, 'get');
    if (params) {
      rb.query('businessunitId', params.businessunitId, {});
      rb.header('x-api-key', params['x-api-key'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkReservationtype>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationtypesV1ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationtypesV1ControllerFindAll(
    params: {
      businessunitId: number;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkReservationtype>> {
    return this.reservationtypesV1ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkReservationtype>>): Array<WorkReservationtype> => r.body)
    );
  }

}
